"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const VideoQualitySettings_1 = __importDefault(require("../devicecontroller/VideoQualitySettings"));
/**
 * [[MeetingFeatures]] contains information on meeting wide configuration which may impact the
 * client.
 */
class MeetingFeatures {
    constructor(videoMaxResolution = VideoQualitySettings_1.default.VideoResolutionHD, contentMaxResolution = VideoQualitySettings_1.default.VideoResolutionFHD) {
        this.videoMaxResolution = videoMaxResolution;
        this.contentMaxResolution = contentMaxResolution;
    }
    /**
     * Returns a deep copy of meeting features.
     */
    clone() {
        return new MeetingFeatures(this.videoMaxResolution, this.contentMaxResolution);
    }
}
exports.default = MeetingFeatures;
